import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  customers: [],
  totalCustomers: 0,
  selectAllField: false,
  selectedCustomers: [],
  viewCustomer:null,
  parentCustomers:[],
  simpleCustomers:[]
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
